import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import idPresentImg from "../../../image/idpresent.svg";
import idPhisicalImg from "../../../image/signature.svg";
import "../../../styles/checkboxCustom.css";
export const Assessment = (logic) => {
    return (
        <Modal
        size="sm"
        windowclass="modal-rounded"
        centered={true}
        show={!logic.solarFinance && logic.assesmentPopup}
        onHide={logic.assesmentPopupClose}
        animation={false}
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: "none", backgroundColor: "#f7f7f8" }}
        >
          <Modal.Title style={{ color: "black", fontSize: "16px" }}>
            A few house rules
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f7f7f8", width: "100%" }}>
          <div>
            <label
              style={{ color: "black", marginBottom: "12px", fontSize: "12px" }}
            >
              By creating a loan offer...
            </label>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "60px",
                backgroundColor: "white",
                marginBottom: 10,
                borderRadius: 8,
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  border: 1,
                  flex: 0.5,
                  marginLeft: 10,
                  marginRight: 10,
                }}
              >
                {" "}
                <label>
                  <input
                    className="checkbox-custom"
                    style={{
                      display: "flex",
                      borderRadius: "100%",
                      height: "20px",
                      width: "20px",
                      appearance: "none", // Add this line to remove default styles
                      borderWidth: "1px", // Add this line to set the border width
                      borderStyle: "solid", // Add this line to set the border style
                      borderColor: "#999", // Add this line to set the border color
                      backgroundColor: logic.isCheckedOption1 ? "#785aff" : "#f7f7f8", // Add this line to set the background color based on the checked state
                    }}
                    type="checkbox"
                    checked={logic.isCheckedOption1}
                    onChange={() => logic.setcheckboxValueOption1(!logic.isCheckedOption1)}
                  />
                </label>
              </div>

              <div
                style={{ display: "flex", flexDirection: "column", flex: 6 }}
              >
                <span
                  style={{ color: "black", fontSize: "12px", lineHeight: 1 }}
                >
                  {logic.promotorConcernDetails.idPresent}
                </span>
              </div>
              <div style={{ flex: 1.5, backgroundColor: "#00ffff00" }}>
                <img
                  className="img1 px-3"
                  style={{ height: "60px" }}
                  src={idPhisicalImg}
                  alt=""
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "60px",
                backgroundColor: "white",
                border: 2,
                borderRadius: 8,
                alignItems: "center",
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  border: 1,
                  flex: 0.5,
                  marginLeft: 10,
                  marginRight: 10,
                }}
              >
                <label>
                  <input
                    className="checkbox-custom"
                    style={{
                      display: "flex",
                      borderRadius: "100%",
                      height: "20px",
                      width: "20px",
                      appearance: "none", // Add this line to remove default styles
                      borderWidth: "1px", // Add this line to set the border width
                      borderStyle: "solid", // Add this line to set the border style
                      borderColor: "#999", // Add this line to set the border color
                      backgroundColor: logic.isCheckedOption2 ? "#785aff" : "#f7f7f8", // Add this line to set the background color based on the checked state
                    }}
                    type="checkbox"
                    checked={logic.isCheckedOption2}
                    onChange={() => logic.setcheckboxValueOption2(!logic.isCheckedOption2)}
                  />
                </label>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", flex: 6 }}
              >
                <span
                  style={{ color: "black", fontSize: "12px", lineHeight: 1 }}
                >
                  {logic.promotorConcernDetails.physicalPresent}{" "}
                </span>
              </div>
              <div style={{ flex: 1.5, backgroundColor: "#00ffff00" }}>
                <img
                  className="img1 px-3"
                  style={{ height: "60px" }}
                  src={idPresentImg}
                  alt=""
                />
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                id="as0"
                type="radio"
                name="tab"
                value="0"
                onClick={() => {
                  logic.setAssesmentValue("0");
                }}
                style={{
                  width: "25%",
                  margin: "5%",
                  flexDirection: "row",
                  height: 80,
                  borderRadius: 8,
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
                }}
              >
                <label
                  id="as0_lable"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    alignSelf: "center",
                  }}
                >
                  0
                </label>
              </div>
              <div
                id="as1"
                type="radio"
                name="tab"
                value="1"
                onClick={() => {
                  logic.setAssesmentValue("1");
                }}
                style={{
                  width: "25%",
                  margin: "5%",
                  height: 80,
                  borderRadius: 8,
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
                }}
              >
                <label
                  id="as1_lable"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  1
                </label>
              </div>
              <div
                id="as2"
                type="radio"
                name="tab"
                value="2"
                onClick={() => {
                  logic.setAssesmentValue("2");
                }}
                style={{
                  width: "25%",
                  margin: "5%",
                  height: 80,
                  borderRadius: 8,
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
                }}
              >
                <label
                  id="as2_lable"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  2
                </label>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <label
                style={{
                  marginBottom: "10px",
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                {logic.promotorConcernDetails.confirmMsg}{" "}
              </label>
            </div>

            <div className="d-grid gap-2">
              <Button
                id="as_proceed"
                className="btn btn-primary p-2"
                style={
                  logic.disableProceed
                    ? {
                        background: "#707070",
                        color: "#e1d5d5",
                        "fontFamily": "inherit",
                      }
                    : {
                        background: "#785aff",
                        color: "#e1d5d5",
                        "fontFamily": "inherit",
                      }
                }
                disabled={logic.disableProceed}
                onClick={logic.proceedQRInfo}
              >
                Proceed
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            color: "white",
            backgroundColor: "#f7f7f8",
            width: "100%",
            borderTop: "none",
          }}
        ></Modal.Footer>
      </Modal>
    );
};

export default Assessment;